import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { LoanAiService, TenantItem } from '../loanAiService';
import { Subscription } from 'rxjs';
import {
  MotifButtonModule,
  MotifIconModule,
  MotifModalModule,
  MotifTableCellRendererComponent,
  MotifTableHeaderRendererComponent,
  MotifTableModule,
  MotifToastModule,
  MotifTooltipModule,
  MotifProgressLoaderModule,
} from '@ey-xd/ng-motif';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IconoirDocMagnifyingGlassIn, MotifActionIcFindInPage24px } from '@ey-xd/motif-icon';
import { LayoutService } from '../_services/layout.service';
import { CommonModule } from '@angular/common';
import { DUMMY_PAYLOADS } from '../constant';
import { FormsModule } from '@angular/forms';
import { IconoirEdit } from '@ey-xd/motif-icon';
import { MotifContentIcSave24px, IconoirCloudUpload, IconoirCheck, } from '@ey-xd/motif-icon';
import { MotifFormsModule } from '@ey-xd/ng-motif';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { environment } from '../../environments/environment';

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

@Component({
  selector: 'app-view-docs',
  standalone: true,
  imports: [
    CommonModule,
    MotifTableModule,
    MotifButtonModule,
    MotifIconModule,
    MotifToastModule,
    MotifModalModule,
    MotifTooltipModule,
    MatSnackBarModule,
    MatIcon,
    FormsModule,
    MotifFormsModule,
    MotifIconModule,
    MotifProgressLoaderModule,
    MatSlideToggleModule,
  ],
  templateUrl: './view-docs.component.html',
  styleUrl: './view-docs.component.scss',
})
export class ViewDocsComponent implements OnInit {
  @ViewChild('motifTable', { read: ElementRef }) motifTable!: ElementRef<any>;
  @ViewChild('docIdTemplate') docIdTemplate!: TemplateRef<any>;
  @ViewChild('fileNameTemplate') fileNameTemplate!: TemplateRef<any>;
  @ViewChild('chunkCountTemplate') chunkCountTemplate!: TemplateRef<any>;
  @ViewChild('activeInactiveTemplate') activeInactiveTemplate!: TemplateRef<any>;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  dataSource: any;
  columnDefs: any;
  docRunId: string | null = null;
  year: string | null = null;
  quarter: string | null = null;
  originPage: number | null = null;
  pagesize: number = 10;
  client_name: string = '';
  private tenantsFull: TenantItem[] = [];
  private tenantsSub: Subscription | undefined;
  private tenantIdSub: Subscription | undefined;
  motifActionIcFindInPage24px = MotifActionIcFindInPage24px;
  iconoirCloudUpload = IconoirCloudUpload;
  iconoirCheck = IconoirCheck;
  obligor_name: string = '';
  facility_type: string = '';
  toastType: ToastType = ToastType.Info;
  ToastType: any;
  type: any;
  toastMessage: string = '';
  showToast: boolean = false;
  @ViewChild('actionsTemplate') actionsTemplate!: TemplateRef<any>;
  @ViewChild('statusTemplate') statusTemplate!: TemplateRef<any>;
  @ViewChild('aiClassified') aiClassified!: TemplateRef<any>;
  @ViewChild('docCategoryTemplate') docCategoryTemplate!: TemplateRef<any>;
  classifiedDropdown: { definition: string; document_category: string }[] = [];

  iconEdit = IconoirEdit;
  isEditMode: boolean = false;
  saveIcon = MotifContentIcSave24px;
  selectedDocId: any = null;
  // Flag to ensure modal only opens after a user-initiated edit
  userInitiatedEdit: boolean = false;
  pdfUrl: import('@angular/platform-browser').SafeResourceUrl = '';
  pdfObjectUrl: string | null = null;
  colFortable: string = 'motif-col-lg-12';
  private _snackBar = inject(MatSnackBar);
  old_label: string = '';
  new_label: string = '';
  documentName: string = '';
  IsLoader: boolean = false;
  confirmationModal: boolean = false;
  isUploadModalOpen: boolean = false;
  uploadSelectedFile: File | null = null;
  uploadTargetRow: any = null;
  isUploadingFile: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loanAiService: LoanAiService,
    private layoutService: LayoutService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    const nav = this.router.currentNavigation && this.router.currentNavigation();
    if (nav && nav.extras && nav.extras.state) {
      this.obligor_name = nav.extras.state['obligor_name'] || '';
      this.facility_type = nav.extras.state['facility_type'] || '';
    } else if (window.history.state) {
      this.obligor_name = window.history.state['obligor_name'] || '';
      this.facility_type = window.history.state['facility_type'] || '';
    }
    // show sidenav
    this.layoutService.displaySideNav(true);
    this.docRunId = this.route.snapshot.paramMap.get('doc_run_id');
    this.quarter = this.route.snapshot.paramMap.get('quarter');
    this.year = this.route.snapshot.paramMap.get('year');
    const pageParam = this.route.snapshot.queryParamMap.get('page');
    if (pageParam) {
      const parsed = parseInt(pageParam, 10);
      this.originPage = isNaN(parsed) ? null : parsed;
    }

    // Subscribe to tenants and tenantId to set client_name when data is available
    this.tenantsSub = this.loanAiService.tenants$.subscribe((tenants: TenantItem[]) => {
      this.tenantsFull = tenants || [];
      // attempt to resolve using saved tenant or current tenantId value
      const saved = localStorage.getItem('tenantId') || '';
      const currentTenantId = saved;
      const matched = this.tenantsFull.find(t => t.tenant_guid === currentTenantId);
      if (matched && matched.tenant_name) {
        this.client_name = matched.tenant_name;
      }
    });

    this.tenantIdSub = this.loanAiService.tenantId$.subscribe((tenantId) => {
      try {
        const matched = this.tenantsFull.find(t => t.tenant_guid === tenantId);
        if (matched && matched.tenant_name) {
          this.client_name = matched.tenant_name;
        }
      } catch (e) { /* ignore */ }
    });

    // Use docRunId and loanType as needed
    this.loadDocs();
    this.getDocLabel();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.columnDefs = [
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Document Category',
          field: 'doc_classification',
          filter: false,
          flex: 2,
          unSortIcon: true,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.docCategoryTemplate,
          },
          cellClass: 'truncate-cell',
          cellStyle: { paddingLeft : '12px' }
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Doc Id',
          field: 'doc_id',
          filter: true,
          flex: 3,
          unSortIcon: true,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.docIdTemplate,
          },
          cellClass: 'truncate-cell',
          cellStyle: { paddingLeft : '12px' }
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'File Name',
          field: 'original_filename',
          filter: false,
          flex: 3,
          unSortIcon: true,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.fileNameTemplate,
          },
          cellClass: 'truncate-cell',
          cellStyle: { paddingLeft : '12px' }
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.aiClassified,
          },
          headerName: '*AI Classified Doc Category',
          field: 'doc_classification',
          filter: false,
          flex: 4,
          unSortIcon: true,
          width: 180,
          minWidth: 180,
          maxWidth: 230,
          cellClass: 'truncate-cell',
          getQuickFilterText: (params: any) => {
            return (params.data?.doc_classification || '') + (params.data?.isPdf ? '' : ' PDF');
          },
        },
        // status and chunk count no longer needed
        // {
        //   headerComponentFramework: MotifTableHeaderRendererComponent,
        //   headerName: 'Chunk Count',
        //   field: 'chunk_count',
        //   filter: false,
        //   flex: 2,
        //   unSortIcon: true,
        //   cellRenderer: MotifTableCellRendererComponent,
        //   cellRendererParams: {
        //     ngTemplate: this.chunkCountTemplate,
        //   },
        //   cellClass: 'truncate-cell',
        //   cellStyle: { paddingLeft : '12px' }
        // },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.statusTemplate,
          },
          headerName: 'Status',
          field: 'classification_indexing_step',
          filter: false,
          flex: 2,
          unSortIcon: false,
          sortable: false,
          cellStyle: { paddingLeft : '12px', paddingRight : '16px'},
          headerClass: 'start-header',
        },
        //uncomment if active/inactive toggle is needed
        // {
        //   headerComponentFramework: MotifTableHeaderRendererComponent,
        //   cellRenderer: MotifTableCellRendererComponent,
        //   cellRendererParams: {
        //     ngTemplate: this.activeInactiveTemplate,
        //   },
        //   headerName: 'Active',
        //   field: 'active',
        //   filter: false,
        //   flex: 2,
        //   width: 80,
        //   minWidth: 80,
        //   maxWidth: 80,
        //   unSortIcon: false,
        //   sortable: false,
        //   cellStyle: { paddingLeft : '12px' }
        // },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.actionsTemplate,
          },
          headerName: 'Actions',
          field: 'template',
          filter: false,
          flex: 2,
          unSortIcon: false,
          sortable: false,
          pinned: 'right',
          maxWidth: 100,
          width: 100,
          cellStyle: { 'border-left-width': '0px', paddingLeft : '12px' },
        },
      ];
    });
    // set suppressRowClickSelection at runtime to avoid needing CUSTOM_ELEMENTS_SCHEMA
    setTimeout(() => {
      try {
        if (this.motifTable && this.motifTable.nativeElement) {
          this.motifTable.nativeElement.suppressRowClickSelection = true;
        }
      } catch (e) {
        // ignore if element not available or property unsupported
      }
    }, 0);
  }

  toggleActive(row: any) {
    const newState = !row.active;
    row.active = newState;
    this.loanAiService.setDocumentActiveStatus(row.doc_id, newState).subscribe({
      next: (res: any) => {
        const msg = res && res.message ? res.message : `Document ${newState ? 'activated' : 'deactivated'}`;
        this._snackBar.open(msg, 'ok', { duration: 2000 });
      },
      error: (err: any) => {
        row.active = !newState;
        console.error('Failed to update active status', err);
        this._snackBar.open('Failed to update document active status', 'ok', { duration: 3000 });
      }
    });
  }
    onToggleEditMode(event: any) {
    this.isEditMode = event.checked;
  }
  goBack() {
    const queryParams: any = { year: this.year, quarter: this.quarter };
    if (this.originPage !== null && this.originPage !== undefined) {
      queryParams.page = this.originPage;
    }
    this.router.navigate(['/view-details'], { queryParams });
  }
  loadDocs() {
    // call getDocRunInfo
    if (this.docRunId) {
      // Pass docRunId, year, and quarter to getDocRunInfo
      this.loanAiService.getDocRunInfo(this.docRunId, this.year, this.quarter).subscribe((data) => {
        this.dataSource = (data || []).map((row: any) => {
          const filename = row['content_disposition_filename'] || row['original_filename'] || '';
          const hasFileName = !!(filename && filename.toString().trim());
          const hasDocId = Object.prototype.hasOwnProperty.call(row, 'doc_id') && row.doc_id !== null && row.doc_id !== undefined;
          const hasDocStatus = Object.prototype.hasOwnProperty.call(row, 'doc_status') && row.doc_status !== null && row.doc_status !== undefined;
          const hasChunkCount = Object.prototype.hasOwnProperty.call(row, 'chunk_count') && row.chunk_count !== null && row.chunk_count !== undefined;
          const docStatus = typeof row.doc_status !== 'undefined' ? !!row.doc_status : true;
          const active = typeof row.active !== 'undefined' ? !!row.active : docStatus;
          const lowerFile = (filename || '').toLowerCase();
          const isPdf = lowerFile.endsWith('.pdf');
          const isExcel = lowerFile.endsWith('.xls') || lowerFile.endsWith('.xlsx');
          const isEditable = isPdf || isExcel;

          // If doc_classification is 'repayment analysis', set status and chunk_count to 'N/A'
          const isRepaymentAnalysis = (row.doc_classification || '').toString().trim().toLowerCase() === 'repayment analysis';
          // For Repayment Analysis documents we want to explicitly show 'N/A' instead of the generic "Missing" pills
          const mappedDocStatus = isRepaymentAnalysis ? 'N/A' : row.doc_status;
          const mappedChunkCount = isRepaymentAnalysis ? 'N/A' : row.chunk_count;
          const mappedDocStatusPresent = isRepaymentAnalysis ? true : hasDocStatus;
          const mappedChunkCountPresent = isRepaymentAnalysis ? true : hasChunkCount;
          return {
            ...row,
            isPdf: isPdf,
            isExcel: isExcel,
            isEditable: isEditable,
            doc_id_present: hasDocId,
            doc_status: mappedDocStatus,
            active: active,
            filename_present: hasFileName,
            doc_status_present: mappedDocStatusPresent,
            chunk_count_present: mappedChunkCountPresent,
            chunk_count: mappedChunkCount,
            // ensure classification_indexing_step.status contains the display value for status template
            classification_indexing_step: {
              ...(row.classification_indexing_step || {}),
              status: isRepaymentAnalysis ? 'N/A' : (row.classification_indexing_step && row.classification_indexing_step.status ? row.classification_indexing_step.status : null),
            },
          };
        });
      });
    }
  }
  
  onUploadClick(row: any, event?: any) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.uploadTargetRow = row;
      this.uploadSelectedFile = null;
      this.isUploadModalOpen = true;
  }
  
  // File input change handler - only allow single excel file
  onUploadFileSelected(event: any) {
      const input: HTMLInputElement = event.target as HTMLInputElement;
      const file = input.files && input.files.length > 0 ? input.files[0] : null;
      if (!file) {
        this.uploadSelectedFile = null;
        return;
      }
      const name = (file.name || '').toLowerCase();
      if (!(name.endsWith('.xls') || name.endsWith('.xlsx'))) {
        // invalid file type
        this.uploadSelectedFile = null;
        try { input.value = ''; } catch (e) {}
        // show snackbar feedback
        try {
          this._snackBar.open('Only .xls or .xlsx files are allowed', 'OK', { duration: 3000 });
        } catch (e) {
          // fallback to toast
          this.toastType = ToastType.Error;
          this.toastMessage = 'Only .xls or .xlsx files are allowed';
          this.showToast = true;
          setTimeout(() => (this.showToast = false), 3000);
        }
        return;
      }
      // accept the file
      this.uploadSelectedFile = file;
    }
  
  // Clear selected file and reset the underlying input so the same file can be re-selected
  clearSelectedFile() {
      this.uploadSelectedFile = null;
      try {
        if (this.fileInputRef && this.fileInputRef.nativeElement) {
          this.fileInputRef.nativeElement.value = '';
        }
      } catch (e) { /* ignore */ }
    }
  
  uploadSubmit() {
  if (!this.uploadSelectedFile) return;
  this.isUploadingFile = true;
  const file = this.uploadSelectedFile;
  // allow upload even when uploadTargetRow is null by falling back to component-level values
  const doc_run_id = (this.uploadTargetRow && (this.uploadTargetRow.doc_run_id || this.uploadTargetRow.request_id)) || this.docRunId || '';
  const tenant_id = localStorage.getItem('tenantId') || '';
  const engagement_id = localStorage.getItem('tenantId') || '';
  const year = this.year || (this.uploadTargetRow && this.uploadTargetRow.year) || '';
  const quarter = this.quarter || (this.uploadTargetRow && this.uploadTargetRow.quarter) || '';
  const obligor_name = this.obligor_name || (this.uploadTargetRow && this.uploadTargetRow.obligor_name) || '';
  const facility_type = this.facility_type || (this.uploadTargetRow && this.uploadTargetRow.facility_type) || '';

    this.loanAiService.uploadDocument(
      file,
      tenant_id,
      engagement_id,
      doc_run_id,
      year,
      quarter,
      obligor_name,
      facility_type
    ).subscribe({
      next: (res: any) => {
        this.isUploadingFile = false;
        try {
          this.uploadTargetRow.upload_doc_ra = this.uploadSelectedFile ? this.uploadSelectedFile.name : true;
          this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : this.dataSource;
        } catch (e) {}
        try {
          this._snackBar.open(res?.message || 'File uploaded successfully', 'OK', { duration: 3000 });
        } catch (e) {
          this.toastType = ToastType.Success;
          this.toastMessage = res?.message || 'File uploaded successfully';
          this.showToast = true;
          setTimeout(() => (this.showToast = false), 3000);
        }
        this.isUploadModalOpen = false;
        this.uploadSelectedFile = null;
        this.uploadTargetRow = null;
        // Refresh the document list to pick up the newly uploaded file
        try {
          this.loadDocs();
        } catch (e) {
          console.error('Failed to refresh document list after upload', e);
        }
      },
      error: (err: any) => {
        this.isUploadingFile = false;
        try {
          this._snackBar.open('Upload failed', 'OK', { duration: 3000 });
        } catch (e) {
          this.toastType = ToastType.Error;
          this.toastMessage = 'Upload failed';
          this.showToast = true;
          setTimeout(() => (this.showToast = false), 3000);
        }
      }
    });
  }
  
  closeUploadModal() {
      this.isUploadModalOpen = false;
      this.uploadSelectedFile = null;
      this.uploadTargetRow = null;
  }

  isDocCategoryDisabled(row: any): boolean {
    if (this.selectedDocId !== row.doc_id) return true;
    return !row.isEditable;
  }

  // Opens a PDF in a new tab using the document ID from the row.
  // Fetches the PDF via loanAiService and displays it.
  showDoc(row: any) {
    this.IsLoader = true;
    this.hidePdf();
    this.documentName = row.original_filename;
    this.loanAiService._dispalyDoc(row.doc_id).subscribe({
      next: (resp) => {
        if (this.pdfObjectUrl) {
          window.URL.revokeObjectURL(this.pdfObjectUrl);
          this.pdfObjectUrl = null;
        }

        const contentDisposition = resp.headers.get('content-disposition') || resp.headers.get('Content-Disposition') || '';
        const blob: Blob = resp.body as Blob;
        const filename = this.extractFileName(contentDisposition) || row.original_filename;
        const isPdf = (blob.type === 'application/pdf') || filename.toLowerCase().endsWith('.pdf');
        if (this.shouldPreview(filename, blob.type, isPdf)) {
          // Show in embedded pdf previewer
            const url = window.URL.createObjectURL(blob);
            this.pdfObjectUrl = url;
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            this.colFortable = 'motif-col-lg-7';
        } else {
          // Force download for attachments or non-PDF types
          const downloadUrl = window.URL.createObjectURL(blob);
          this.pdfObjectUrl = downloadUrl;
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          this.colFortable = 'motif-col-lg-12';
          this.pdfUrl = '';
          this.documentName = '';
        }
        this.IsLoader = false;
      },
      error: (err) => {
        console.error('Failed to load document', err);
        this.IsLoader = false;
      }
    });
  }

  private extractFileName(contentDisposition: string): string | null {
    if (!contentDisposition) return null;
    const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i;
    const match = filenameRegex.exec(contentDisposition);
    if (match) {
      return decodeURIComponent(match[1] || match[2]);
    }
    return null;
  }

  private shouldPreview(filename: string, mime: string, isPdf: boolean): boolean {
    const lower = filename.toLowerCase();
    const officeExts = ['.doc', '.docx', '.xlsx', '.ppt', '.pptx'];
    if (officeExts.some(ext => lower.endsWith(ext))) return false;
    return isPdf;
  }

  hidePdf() {
    if (this.pdfObjectUrl) {
      window.URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    }
    this.pdfUrl = '' as any;
    this.colFortable = 'motif-col-lg-12';
    this.documentName = '';
    this.pdfUrl = '' as any;
  }

  closePdf() {
    if (this.pdfObjectUrl) {
      window.URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    }
    this.pdfUrl = '' as any;
    this.colFortable = 'motif-col-lg-12';
  }

  getDocLabel() {
    this.loanAiService.getDocLabel().subscribe({
      next: (data) => {
        this.classifiedDropdown = data.document_categories;
      },
      error: (err) => {
        console.error('Failed to fetch document labels:', err);
        this.classifiedDropdown = [];
      },
    });
  }

  editAiClassified(id: string, doc_classification: string) {
    this.selectedDocId = id;
    this.old_label = doc_classification;
    // Mark that the following changes are user-initiated (click on edit icon)
    this.userInitiatedEdit = true;
  }

  updateAiClassified(new_label: string, doc_id: string) {
    this.selectedDocId = '';
    this.confirmationModal = false;
    this.loanAiService
      ._updateDocLabel({ new_label, doc_id, old_label: this.old_label })
      .subscribe({
        next: (data) => {
          this._snackBar.open(data.message, 'ok', { duration: 2000 });
        },
        error: (err) => {
          this._snackBar.open('Failed to update document label', 'ok', {
            duration: 2000,
          });
        },
      });
  }
  OpenconfirmationModal(doc_classification: string) {
    // Only open the confirmation modal when the classification actually changes
    // (prevents ngModelChange firing during initial rendering from opening it)
    this.new_label = doc_classification;
    if (this.new_label === this.old_label) {
      this.confirmationModal = false;
      // reset user-initiated flag so subsequent changes require a fresh edit
      this.userInitiatedEdit = false;
      return;
    }
    // Only open if user initiated the edit (prevents programmatic/initial change)
    if (!this.userInitiatedEdit) {
      this.confirmationModal = false;
      return;
    }
    this.confirmationModal = true;
    // Consume the user-initiated flag so a subsequent ngModelChange won't re-open
    this.userInitiatedEdit = false;
  }
  ngOnDestroy(): void {
    if (this.pdfObjectUrl) {
      window.URL.revokeObjectURL(this.pdfObjectUrl);
    }
  }

  formatStatus(status: string | undefined | null): string {
    if (status === null || status === undefined) return '';
    const s = status.toString().trim();
    if (!s) return '';
    // If a status explicitly set to 'N/A' (case-insensitive), return it as-is
    if (s.toLowerCase() === 'n/a' || s.toLowerCase() === 'na') return 'N/A';
    const lower = s.toLowerCase();

    if (lower === 'completed') return 'Completed';
    if (lower === 'partial' || lower === 'partial_completed' || lower === 'partialcompleted') return 'Partial';
    if (lower === 'failed') return 'Failed';
    if (lower === 'in_progress' || lower === 'inprogress' || lower === 'in progress') return 'In Progress';
    if (lower === 'pending') return 'Pending';
    if (lower === 'skipped') return 'Skipped';
    // New handling for incomplete variants
    if (lower === 'in_complete' || lower === 'incomplete' || lower === 'in complete') return 'Incomplete';

    const cleaned = s.replace(/_/g, ' ').toLowerCase();
    return cleaned.replace(/(^|\s)\S/g, (t) => t.toUpperCase());
  }
}
